import { Backdrop,  Paper, Typography } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';

import React from "react";


// MUI version
export function Overlay({ isVisible, legend }: { isVisible: boolean, legend: string | null }) {
    const theme = useTheme();
   if (!isVisible) return null;
  
return (
    <Backdrop
      open={isVisible}
      style={{
        position: 'absolute', // Use absolute for section overlay
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        justifyContent: 'center',  // Horizontal centering
        display: 'flex',           // Ensure flexbox
        alignItems: 'center',      // Vertical centering
      }}
    >
      <Paper
        elevation={8}
        style={{
          padding: 3,
          borderRadius: '10px',
          border: '2px solid var(--font-color-disabled)',
          textAlign: 'center',
          display: 'flex',          // Make paper a flex container
          flexDirection: 'column',  // Stack title and legend vertically
          justifyContent: 'center', // Center content vertically within paper
          backgroundColor: 'var(--onhold-overlay-bg)',
          opacity: 0.55,
          minWidth: 480,
          maxWidth: 680,
          minHeight: 120,
        }}
      >
        <Typography variant="h5" style={{ marginBottom: 2 }}>
          On Hold
        </Typography>
        <Typography variant="body1">
          {legend}
        </Typography>
      </Paper>
    </Backdrop>
  );
};